"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssuedCardRoutes = void 0;
const route_1 = require("../route");
class IssuedCardRoutes extends route_1.Route {
    constructor() {
        super('cards');
    }
    issueNew() {
        return this.post('/');
    }
    getActive() {
        return this.get('/active');
    }
    fund(cardId, amount, currency) {
        return this.post(`/fund/${cardId}`, { amount, currency });
    }
    withdraw(cardId, amount, currency) {
        return this.post(`/withdraw/${cardId}`, { amount, currency });
    }
    freeze(cardId) {
        return this.post(`/freeze/${cardId}`);
    }
    unfreeze(cardId) {
        return this.post(`/unfreeze/${cardId}`);
    }
    getBalance(cardId) {
        return this.get(`/balance/${cardId}`);
    }
    fetchTransactions(cardId) {
        return this.post(`/transactions/update/${cardId}`);
    }
}
exports.IssuedCardRoutes = IssuedCardRoutes;
//# sourceMappingURL=cards.js.map